/**
 * filterFaces.js
 *
 * @description The logic used to filter faces throughout the app.
 */

/**
 * Filters a collection of faces by searchTerm.
 *
 * @export
 * @param {any} searchTerm The search term.
 * @param {any} faces The faces to filter.
 * @returns A list of faces matching the search term.
 */
export function filterFaces (text, faces, hasCanSearchEmployeeEntitlement, cards = true) {
  if (!faces) {
    return undefined
  }
  if (!text) {
    return faces.filter(face => {
      if (!cards && face.card) {
        return false
      }
      if (face.person_name.toLowerCase().includes('visitor')) return false
      const faceIsEmployee = face.role === 'employee' || face.employee
      /** Block staff from spying on each other. */
      if (!hasCanSearchEmployeeEntitlement && faceIsEmployee) {
        return false
      }
      return true
    })
  }

  const searchTerm = text.toLowerCase()
  return faces.filter(face => {
    // console.log(`role ${face.role}`)
    const faceIsEmployee = face.role === 'employee' || face.employee
    /** Block staff from spying on each other. */
    if (!hasCanSearchEmployeeEntitlement && faceIsEmployee) {
      return false
    }

    /** Don't show visitors */
    const personName = face.person_name.toLowerCase()
    if (personName.includes('visitor')) return false

    if (personName.toLowerCase().includes(searchTerm)) return true

    // Staff Role + Synonym
    if ('staff'.startsWith(searchTerm) && faceIsEmployee) {
      return true
    }

    // Resident Role
    if ('resident'.startsWith(searchTerm) && face.resident) return true

    // General Role
    if (face.role && face.role.toLowerCase().includes(searchTerm)) return true
    if (face.complexion && face.complexion.toLowerCase().includes(searchTerm)) return true
    if (face.complexion && 'african american'.includes(searchTerm) && face.complexion === 'black') return true // required, since the db stores as 'black'
    if (face.complexion && 'white'.includes(searchTerm) && face.complexion === 'caucasian') return true // support common synonym
    if (face.elopement_risk && 'elopement risk'.includes(searchTerm)) return true

    // Resident Room
    if (face.room && face.room.toLowerCase().includes(searchTerm.toLowerCase())) return true

    // Last Seen
    if (face.last_seen_camera_description && face.last_seen_camera_description.toLowerCase().includes(searchTerm)) return true
  })
}
